(() => {
  const selector = '.product__accordion--custom details';
  const duration = 300;

  function finish(panel, height) {
    panel.style.height = height;
    panel.style.overflow = '';
  }

function animate(details, opening) {
    const panel = details.querySelector('.custom-accordion__panel');
    const summary = details.querySelector('summary');
    if (!panel || !summary) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      details.open = opening;
      details.classList.toggle('custom-collapsible-row--is-open', opening);
      panel.style.height = opening ? 'auto' : '';
      summary.setAttribute('aria-expanded', opening);
      return;
    }

    panel.getAnimations().forEach((animation) => animation.cancel());
    summary.setAttribute('aria-expanded', opening);

    if (opening) {
      details.open = true;
      details.classList.add('custom-collapsible-row--is-open');
      panel.style.overflow = 'hidden';
      panel.style.height = '0px';

      requestAnimationFrame(() => {
        panel.style.height = `${panel.scrollHeight}px`;
      });

      const onOpenEnd = (event) => {
        if (event.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onOpenEnd);
        finish(panel, 'auto');
      };
      panel.addEventListener('transitionend', onOpenEnd);
      return;
    }

    panel.style.overflow = 'hidden';
    panel.style.height = `${panel.scrollHeight}px`;
    details.classList.remove('custom-collapsible-row--is-open');

    requestAnimationFrame(() => {
      panel.style.height = '0px';
    });

    const onCloseEnd = (event) => {
      if (event.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onCloseEnd);
      details.open = false;
      finish(panel, '');
    };
    panel.addEventListener('transitionend', onCloseEnd);
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest(`${selector} > summary`);
    if (!summary) return;

    event.preventDefault();
    const details = summary.parentElement;
    animate(details, !details.open);
  });

  document.querySelectorAll(selector).forEach((details) => {
    const summary = details.querySelector('summary');
    const panel = details.querySelector('.custom-accordion__panel');
    details.classList.add('custom-collapsible-row--ready');
    details.classList.toggle('custom-collapsible-row--is-open', details.open);
    if (details.open && panel) panel.style.height = 'auto';
    if (summary) summary.setAttribute('aria-expanded', details.open);
  });
})();
